<template>
    <section id="page10">
        <div class="container">
            <div class="col-unique">
                <div class="">
                    <h2>
                        Depoimentos de quem já alçou voo com a gente!
                    </h2>
                    <p>
                        Veja o que dizem os nossos clientes sobre as soluções digitais que desenvolvemos e o impacto gerado para seus colaboradores e para o negócio.
                    </p>
                </div>
            </div>
        </div>
         <div class="container container-bottom" data-aos="fade" data-aos-delay="600">
            <div class="swipercards">
                <swiper ref="mySwiper" :options="swiperOptions" @slideChange="runOnChange">
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page10-img2.png" alt="" @load="loadImage">
                                <!-- <h2>CAIXA</h2> -->
                                <div class="quote">
                                    <!-- <img src="@/assets/img/icon-quoteinit.svg" alt="" class="quoteinit"> -->
                                    <p>
                                        Temos a Academia da Excelência, que é voltada para o desenvolvimento e engajamento de talentos. 
                                        Utilizamos estratégias de games, <em>chatbot</em>, divisão de conteúdo em <em>playlists</em>, relatórios diferenciados e mensageria automática 
                                        para melhorar a experiência dos profissionais, bem como para promover um maior consumo de conteúdo pelo público.
                                    </p>
                                    <!-- <img src="@/assets/img/icon-quoteend.svg" alt="" class="quoteend"> -->
                                </div>
                                
                                <p class="noticia">
                                    Em 2019, a Universidade CAIXA recebeu o troféu Ouro, na categoria Inovação, entre as melhores universidades corporativas do mundo.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page10-img3.png" alt="" @load="loadImage">
                                <!-- <h2>Claro</h2> -->
                                <div class="quote">
                                    <!-- <img src="@/assets/img/icon-quoteinit.svg" alt="" class="quoteinit"> -->
                                    <p>
                                        O processo de certificação dos nossos vendedores tem início com games, com aplicação de situações reais. 
                                        De acordo com as decisões tomadas pelo participante, sua pontuação é gerada em uma matriz de competências com vários indicadores. 
                                        Fazemos a medição, no mínimo, sete vezes de cada indicador. De acordo com as escolhas do vendedor, vamos mostrando caminhos diferentes dentro do game. 
                                        O seja, ele tem a resposta imediata e o impacto dela no cliente em tempo real.
                                    </p>
                                    <!-- <img src="@/assets/img/icon-quoteend.svg" alt="" class="quoteend"> -->
                                </div>
                                
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page10-img4.png" alt="" @load="loadImage">
                                <!-- <h2>Monsanto</h2> -->
                                <div class="quote">
                                    <!-- <img src="@/assets/img/icon-quoteinit.svg" alt="" class="quoteinit"> -->
                                    <p>
                                        O game tem como objetivo facilitar a interação entre os candidatos e a Monsanto. 
                                        Para os profissionais, é um aprendizado e uma oportunidade de participar de um processo seletivo inovador e mais dinâmico. 
                                        Para a Monsanto, encontrar o melhor profissional de uma forma diferente da usualmente utilizada pela maioria das empresas.
                                    </p>
                                    <!-- <img src="@/assets/img/icon-quoteend.svg" alt="" class="quoteend"> -->
                                </div>
                                
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="fade"  data-aos-delay="300">
                                <img src="@/assets/img/page10-img5.png" alt="" @load="loadImage">
                                <!-- <h2>Renner</h2> -->
                                <div class="quote">
                                    <!-- <img src="@/assets/img/icon-quoteinit.svg" alt="" class="quoteinit"> -->
                                    <p>
                                        Antes da utilização do game, nossa primeira etapa do processo seletivo, que era também o principal filtro, 
                                        era baseada na análise de currículo e teste de lógica. A partir do momento que começamos a utilizar o jogo 
                                        (construído com base nos desafios e em algumas competências necessárias para a função), pudemos também analisar 
                                        o candidato pela aderência dos seus valores e perfil de acordo com o que buscamos para as nossas oportunidades. 
                                        Essa mudança nos trouxe maior assertividade na escolha dos candidatos que evoluíram para a etapa presencial.
                                    </p>
                                    <!-- <img src="@/assets/img/icon-quoteend.svg" alt="" class="quoteend"> -->
                                </div>
                            </div>
                        </article>
                    </swiper-slide>
                    <!-- <div class="swiper-button-prev swiper-button-prev1" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-next1" slot="button-next"></div> -->
                </swiper>
                <div class="bullets">
                    <div class="swiper-pagination swiper-pagination4" slot="pagination"></div>
                </div>
            </div>
        </div>
        <div class="parallax">
            <div id="planet1" class="planeta">
                <img src="@/assets/img/page10-planet1.png" alt="" data-depth=".5">
            </div>
            <div id="planet2" class="planeta">
                <img src="@/assets/img/page10-planet2.png" alt="" data-depth=".5">
            </div>
            <div id="planet3" class="planeta">
                <img src="@/assets/img/page10-planet3.png" alt="" data-depth=".3">
            </div>
            <div id="rocket" class="planeta">
                <img src="@/assets/img/page10-rocket.png" alt="" data-depth="1.7">
            </div>
        </div>
    </section>
</template>
<script>
// import { create } from '@lottiefiles/lottie-interactivity';
import Parallax from 'parallax-js'
// import gsap from "gsap";
export default {
    props: ['persona'],
    data() {
        return {
            totalImages: 4,
            countImages: 0,
            swiperOptions: {
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: '.swiper-pagination4',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                breakpoints: {
                    1140: {
                        slidesPerView: 2,
                    },
                    900: {
                        slidesPerView: 1,
                    }
                }
            }

        }
    },
    computed: {
        swiper() {
        return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        loadImage() {
            this.countImages++;
            if(this.countImages == this.totalImages) {
                this.$emit("refreshAos");
            }
        },
         runOnChange(evt) {
            if(this.$refs.mySwiper.$swiper.activeIndex==(this.$refs.mySwiper.$children.length-1)){
                // console.log("FINALIZOU");
            }
        }
    },
    mounted() {
        var scene = document.getElementById('planet1');
        var parallaxInstance = new Parallax(scene);
        var scene = document.getElementById('planet2');
        var parallaxInstance = new Parallax(scene);
        var scene = document.getElementById('planet3');
        var parallaxInstance = new Parallax(scene);
        var scene = document.getElementById('rocket');
        var parallaxInstance = new Parallax(scene);
        // gsap.to("#persona", {
        //     duration: 1.5,
        //     y: -20,
        //     repeat: -1,
        //     yoyo: true
        // });
        // if(this.persona == 0) {
        //     this.$refs.lottiepage11.addEventListener('load', function() {
        //         create({
        //                 mode:"scroll",
        //                 player: '#page11anima0',
        //                 actions: [
        //                     {
        //                         visibility: [0, 1],
        //                         type: "loop"
        //                     }
        //                 ],
        //         });
        //     })
        // } else {
        //     this.$refs.lottiepage11.addEventListener('load', function() {
        //         create({
        //                 mode:"scroll",
        //                 player: '#page11anima1',
        //                 actions: [
        //                     {
        //                         // visibility: [0, .2],
        //                         type: "loop"
        //                     }
        //                 ],
        //         });
        //     })
        // }
    }
}
</script>
<style lang="scss" scoped>
section {
    
    background: rgb(72,13,141);
    background: radial-gradient(circle, rgba(62,95,172,1) 0%, rgba(44,34,102,1) 100%);
    background-repeat: no-repeat;
    // background-size: auto;
    background-attachment: fixed;
    color: $color-text-light;
    position: relative;
    .swipercards {
        display: block;
        width: 100%;
        article {
            width: 100%;
            max-width: 525px;
            margin-left: 10px;
            margin-right: 10px;
            border-radius: 28px;
            box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
            border: 1px solid #B2B2B2;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            // overflow: hidden;
            background-color: white;
            color: $color-text-dark;
            text-align: center;
            // width: 902px;
            // height: 253px;
            min-height: 500px;
            padding-left: 15px;
            padding-right: 15px;
            padding-top: 15px;
            padding-bottom: 15px;
            img {
                // border-radius: 20px;
                max-width: 128px;
                padding-bottom: 30px;
            }
            h2 {
                padding-top: 30px;
                padding-bottom: 20px;
            }
            .tagline {
                color: $color-secondary;
                font-weight: bold;
                padding-bottom: 30px;
            }
            ul {
                list-style-position: inside;
                line-height: 1.7rem;
                padding-bottom: 10px;
            }
            .box {
                background-color: rgba(0, 0, 0, .1);
                border-radius: 20px;
                padding: 20px;
            }
            .quote {
                display: flex;
                align-items: center;
                p {
                    line-height: 2rem;
                }
                .quoteinit {
                    align-self: flex-start
                }
                .quoteend {
                    align-self: flex-end;
                }
            }
            .noticia {
                padding-top: 30px;
                font-style: italic;
            }
        }
        .bullets {
            height: 100px;
            display: flex;
            justify-content: center;
        }
    }
    .parallax {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    #planet1 {
        position: absolute;
        top: 474px;
        left: -250px;
        z-index: 100;
    }
    #planet2 {
        position: absolute;
        top: 248px;
        right: 30px;
        z-index: 101;
    }
    #planet3 {
        position: absolute;
        top: 551px;
        right: 50px;
        z-index: 102;
    }
    #rocket {
        position: absolute;
        top: 100px;
        left: 20px;
        z-index: 103;
    }
    .container {
        position: relative;
        z-index: 110;
        padding-top: 120px;
        padding-bottom: 56px;
        // justify-content: flex-start;
        align-items: flex-start;
        .col-unique {
            max-width: 525px;
            h2 {
                padding-bottom: 30px;
            }
        }

    }
    .sticky {
        position: sticky;
        position: -webkit-sticky;
        overflow: auto;
        top: 0;
        padding-top: 130px;
    }
    @media only screen and (max-height: 830px) {
        .sticky {
            position: relative;
            // position: -webkit-sticky;
            overflow: auto;
            top: 0;
            padding-top: 0;
        }
    }
    @media only screen and (max-width: 1600px) {
        #rocket {
            display: none;
        }
    }
    @media only screen and (max-width: 1140px) {
        .planeta {
            display: none;
        }
        .container {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .col-left {
                flex-basis: 100%;
                padding-bottom: 30px;
                text-align: center;
            }
            .col-right {
                flex-basis: 100%;
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .swipercards {
            article {
                min-height: 700px;
            }
        }
        .container {
            
            .col-right {
                display: none;
                flex-direction: column;
                .cards-right {
                    margin-top: 0;
                    margin-bottom: 0;
                }
                .card {
                    .quote {
                        .quoteinit {
                            display: none;
                        }
                        .quoteend {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>